import { Icon } from '../Icon/Icon';

type BannerType = 'success' | 'info' | 'error' | 'lock';

type Props = {
  type: BannerType;
  title?: string;
  content: string;
  marginTop?: string;
  marginBottom?: string;
};

export const InfoBanner = ({
  type,
  title,
  content,
  marginTop,
  marginBottom,
}: Props) => {
  return (
    <div
      className={`bc-info-banner bc-info-banner--${type}`}
      style={{ marginTop, marginBottom }}
    >
      {title ? (
        <>
          <div className="bc-info-banner__title">
            <Icon iconName={type} height={24} width={24} />
            {title}
          </div>
          {content}
        </>
      ) : (
        <>
          <div style={{ display: 'inline-block' }}>
            <Icon iconName={type} height={24} width={24} />
          </div>
          {content}
        </>
      )}
    </div>
  );
};
